












































  import { CMS } from '@one/types'
  import {
    computed,
    defineComponent,
    getCurrentInstance,
    PropType,
    ref,
  } from 'vue'

  type SiteSection = CMS.SiteSections.SiteSection

  interface Props {
    siteSection: SiteSection
  }

  export default defineComponent({
    name: 'OneSiteSectionsNodeList',
    props: {
      siteSection: {
        type: Object as PropType<SiteSection>,
        required: true,
      },
    },
    setup(props: Props) {
      const instance = getCurrentInstance()
      const isCollapsed = ref(false)

      const normalizePath = (path: string): string => {
        const trimmed = path.trim()
        const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
        return normalized.endsWith('/') && normalized.length > 1
          ? normalized.slice(0, -1)
          : normalized
      }

      const currentPath = computed(() => {
        return normalizePath((instance?.proxy as any)?.$route?.path || '/')
      })

      const sectionPath = computed(() => normalizePath(props.siteSection.slug))

      const isPathActive = (path: string, exact: boolean = false): boolean => {
        const normalizedPath = normalizePath(path)

        if (exact) {
          return currentPath.value === normalizedPath
        }

        return currentPath.value === normalizedPath || currentPath.value.startsWith(`${normalizedPath}/`)
      }

      const toggleCollapse = (): void => {
        isCollapsed.value = !isCollapsed.value
      }

      return {
        sectionPath,
        isPathActive,
        isCollapsed,
        toggleCollapse,
      }
    },
  })

